import React from "react"
import PropTypes from "prop-types"
import { Modal } from "@bitcine/cs-theme"
import dayjs from "dayjs"
import DatePicker from "react-datepicker"

const CustomDatePicker = ({ value, onClick, onClear }) => (
  <button className='cs-button white' style={{ width: "300px", paddingLeft: "40px" }} onClick={onClick}>
    {value ? value : "None Selected"}
    {value ? <span
      className='material-icons'
      onClick={e => {
        e.stopPropagation()
        onClear()
      }}
      style={{ position: "absolute", right: "10px", top: "10px", fontSize: "20px", color: "#666" }}>close</span>
    : null}
  </button>
)

CustomDatePicker.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
}

const getDate = value => {
  if (value && dayjs(value).isValid()) {
    return dayjs
      .utc(value)
      .local()
      .toDate()
  }
  return null
}

class ExpiryPickerModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expiry: props.expiry
    }
  }
  save() {
    this.setState({ pending: true })
    this.props.onSave(this.state.expiry)
  }
  render() {
    return (
      <Modal title={this.props.title} open={true} onClose={() => this.props.onClose()}>
        <div>
          <label className='cs-label' htmlFor='expiry'>
            Expires At (local time):
          </label>
          <DatePicker
            selected={getDate(this.state.expiry)}
            onChange={e => this.setState({ expiry: e.toISOString() })}
            minDate={new Date()}
            showTimeSelect
            timeFormat='HH:mm'
            timeIntervals={1}
            timeCaption='time'
            dateFormat='MMMM d, yyyy h:mm aa'
            shouldCloseOnSelect={false} 
            showTimeInput 
            customInput={<CustomDatePicker onClear={() => this.setState({ expiry: null })}/>}/>
          <p className='italic mt1'>
            {this.state.expiry ? (
              <span>
                UTC: {dayjs.utc(this.state.expiry).format("MMMM D, YYYY [at] h:mma")}
              </span>
            ) : (
              <span>Never expires.</span>
            )}
          </p>
        </div>
        {this.props.message && (
          <p className='red mt2'>{this.props.message}</p>
        )}
        <button
          onClick={() => this.save()}
          disabled={(this.props.expiry === this.state.expiry) || this.state.pending || this.props.disabled}
          className='cs-button mt2'>
          Confirm Expiry Date
        </button>
      </Modal>
    )
  }
}

ExpiryPickerModal.propTypes = {
  title: PropTypes.string.isRequired,
  expiry: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  message: PropTypes.string
}

export default ExpiryPickerModal
